var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.997 64c-0.49 0-0.954-0.224-1.258-0.611-0.182-0.234-4.538-5.805-8.95-14.032-2.598-4.842-4.672-9.597-6.16-14.131-1.878-5.718-2.829-11.11-2.829-16.026 0-10.586 8.614-19.2 19.2-19.2s19.2 8.614 19.2 19.2c0 4.915-0.954 10.304-2.829 16.026-1.488 4.534-3.562 9.29-6.16 14.131-4.416 8.227-8.768 13.798-8.95 14.032-0.304 0.387-0.768 0.611-1.258 0.611h-0.006zM31.997 3.2c-8.822 0-16 7.178-16 16 0 10.413 4.682 21.325 8.611 28.643 2.886 5.379 5.789 9.645 7.389 11.872 1.606-2.237 4.528-6.528 7.418-11.923 3.914-7.306 8.582-18.198 8.582-28.592 0-8.822-7.178-16-16-16z",
    fill: "#095797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.997 28.8c-5.293 0-9.6-4.307-9.6-9.6s4.307-9.6 9.6-9.6c5.293 0 9.6 4.307 9.6 9.6s-4.307 9.6-9.6 9.6zM31.997 12.8c-3.53 0-6.4 2.87-6.4 6.4s2.87 6.4 6.4 6.4c3.53 0 6.4-2.87 6.4-6.4s-2.87-6.4-6.4-6.4z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisation);
export default __webpack_public_path__ + "static/media/localisation.c9bc7a279113a1d9795fdd0674fda2d9.svg";
export { ForwardRef as ReactComponent };